const DirectionIcon = ({ width = 42, height = 42, color = '#000000', ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      {...props}
      viewBox="0 0 42 42"
      fill="none">
      <path
        d="M10.1504 7.875L10.1504 11.375L29.4004 11.375L31.1504 9.625L29.4004 7.875L10.1504 7.875Z"
        fill={color}
      />
      <path
        d="M34.124 31.8477L30.624 31.8477L30.624 12.5977L32.374 10.8477L34.124 12.5977L34.124 31.8477Z"
        fill={color}
      />
      <path
        d="M6.99911 32.5252L9.47399 35L27.8938 16.5799L28.0357 13.9631L25.4189 14.105L6.99911 32.5252Z"
        fill={color}
      />
    </svg>
  )
}

export default DirectionIcon
